import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import { DEFAULT_GALLERY_VIEW } from "@ext/markdown/elements/gallery/model/gallery";

const galleryFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		const view = node.attrs.view === DEFAULT_GALLERY_VIEW ? undefined : node.attrs.view;
		await state.wrapContainer(
			formatter.openTag("gallery", { view, title: node.attrs.title, scale: node.attrs.scale }),
			formatter.closeTag("gallery"),
			node,
			async () => await state.renderContent(node),
			formatter.indentsContainers,
		);
	};

export default galleryFormatter;
